/**
 * Questionnaire v2 — persistance date de mariage (étape 1 → étape 17)
 * Chargé sans defer pour capturer la date avant tout déplacement DOM.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'qv2-wedding-date';

  function getStoreEl() {
    return document.getElementById('qv2-wedding-date-store');
  }

  function isWeddingDateInput(el) {
    if (!el || !el.tagName) return false;
    if (el.id === 'qv2-wedding-date' || el.id === 'wedding-date') return true;
    return el.name === 'wedding-date';
  }

  function readFromDom() {
    var host = document.querySelector('[data-qv2-steps-host]');
    if (host) {
      var hostInput = host.querySelector('[data-step="1"] input[name="wedding-date"], [data-step="1"] #qv2-wedding-date');
      if (hostInput && hostInput.value) return hostInput.value.trim();
    }
    var direct = document.getElementById('qv2-wedding-date');
    if (direct && direct.value) return direct.value.trim();
    var named = document.querySelector('input[name="wedding-date"]');
    if (named && named.value) return named.value.trim();
    return '';
  }

  function readFromStorage() {
    var store = getStoreEl();
    if (store && store.value) return store.value.trim();
    try {
      return sessionStorage.getItem(STORAGE_KEY) ||
        localStorage.getItem(STORAGE_KEY) ||
        '';
    } catch (e) {
      return '';
    }
  }

  function formatFrench(iso) {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso || '';
    var p = iso.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }

  function getMinimumWeddingDate() {
    if (window.QV2 && typeof window.QV2.getMinimumWeddingDate === 'function') {
      return window.QV2.getMinimumWeddingDate();
    }
    var today = new Date();
    var minDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    var year = minDate.getFullYear();
    var month = String(minDate.getMonth() + 1).padStart(2, '0');
    var day = String(minDate.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function isDateAllowed(iso) {
    var min = getMinimumWeddingDate();
    if (!iso || !min) return false;
    return iso >= min;
  }

  function setWeddingDate(iso) {
    var value = (iso || '').trim();
    var min = getMinimumWeddingDate();
    if (value && min && value < min) {
      value = min;
    }
    var store = getStoreEl();
    if (store) store.value = value;
    if (value) {
      document.body.setAttribute('data-qv2-wedding-date', value);
      try {
        sessionStorage.setItem(STORAGE_KEY, value);
        localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('qv2:weddingDateChanged', {
      detail: { value: value }
    }));
    return value;
  }

  function getWeddingDate() {
    var dom = readFromDom();
    if (dom) {
      if (dom !== readFromStorage()) setWeddingDate(dom);
      return dom;
    }
    return readFromStorage();
  }

  function captureWeddingDate() {
    var dom = readFromDom();
    if (dom) return setWeddingDate(dom);
    return readFromStorage();
  }

  function restoreStep1Input() {
    var saved = readFromStorage();
    if (!saved) return;
    var min = getMinimumWeddingDate();
    if (saved && min && saved < min) {
      saved = setWeddingDate(min);
    }
    document.querySelectorAll('input[name="wedding-date"], #qv2-wedding-date, #wedding-date').forEach(function (input) {
      if (!input) return;
      input.setAttribute('min', min);
      if (!input.value || (min && input.value < min)) {
        input.value = saved;
      }
    });
  }

  function syncStep17Fields() {
    var iso = getWeddingDate();
    var display = document.getElementById('account-wedding-date-display');
    var hidden = document.getElementById('RegisterForm-WeddingDate');
    var recap = document.getElementById('account-wedding-date-recap');
    var formatted = iso ? formatFrench(iso) : '';

    if (hidden) {
      hidden.value = iso;
      hidden.readOnly = true;
    }
    if (display) {
      display.textContent = formatted || '—';
      display.setAttribute('data-iso-date', iso || '');
    }
    if (recap) {
      recap.classList.toggle('form-field-invalid', !iso);
    }
    return iso;
  }

  function onDateInputEvent(e) {
    if (!isWeddingDateInput(e.target)) return;
    var value = (e.target.value || '').trim();
    if (value) setWeddingDate(value);
  }

  function bindDelegatedListeners() {
    if (document.documentElement.dataset.qv2WeddingDateBound) return;
    document.documentElement.dataset.qv2WeddingDateBound = '1';

    ['input', 'change', 'blur'].forEach(function (eventName) {
      document.addEventListener(eventName, onDateInputEvent, true);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-next-step], #qv2-validate-step-1') : null;
      if (!btn) return;
      captureWeddingDate();
    }, true);

    document.addEventListener('qv2:stepShown', function (e) {
      if (!e.detail || Number(e.detail.step) !== 17) return;
      captureWeddingDate();
      syncStep17Fields();
      setTimeout(syncStep17Fields, 0);
      setTimeout(syncStep17Fields, 150);
    });

    document.addEventListener('qv2:weddingDateChanged', function () {
      if (document.getElementById('account-wedding-date-display')) {
        syncStep17Fields();
      }
    });
  }

  function init() {
    bindDelegatedListeners();
    var saved = readFromStorage();
    if (saved) {
      setWeddingDate(saved);
      restoreStep1Input();
      document.querySelectorAll('input[name="wedding-date"], #qv2-wedding-date, #wedding-date').forEach(function (input) {
        var min = getMinimumWeddingDate();
        if (input) {
          input.setAttribute('min', min);
          if (input.value && !isDateAllowed(input.value)) {
            input.value = min;
          }
        }
      });
    }
  }

  window.QV2_WEDDING_DATE = {
    get: getWeddingDate,
    set: setWeddingDate,
    capture: captureWeddingDate,
    syncStep17: syncStep17Fields,
    formatFrench: formatFrench,
    getMinimum: getMinimumWeddingDate,
    isAllowed: isDateAllowed
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
